import { ThemeProvider } from 'styled-components'

import { ProgressBarFiller, ProgressBarContainer, ServiceHeader, ServiceInfo } from '../styles'
import { Icons } from '../config'
import { Service } from '../types'
import * as Styles from './styles'

type ModalSectionProps = {
  sectionTitle: string
  services?: Service[]
}

export const ModalSection = ({ sectionTitle, services }: ModalSectionProps) => {
  return (
    <Styles.SectionContainer>
      <Styles.SectionTitle>{sectionTitle}</Styles.SectionTitle>
      <Styles.SectionContent>
        {services?.map((service: Service) => {
          const { formattedProgress = '', percentageProgress = 0 } = service.calculatedProgress
          return (
            <ThemeProvider key={service.id} theme={service.theme}>
              <Styles.ListItem>
                <Icons service={service} isActive={false} isLoading={false} />
                <ServiceInfo>
                  <ServiceHeader>
                    <span>{service.title}</span>
                    <span>{formattedProgress}</span>
                  </ServiceHeader>
                  <ProgressBarContainer isActive={false}>
                    <ProgressBarFiller progress={percentageProgress} />
                  </ProgressBarContainer>
                </ServiceInfo>
              </Styles.ListItem>
            </ThemeProvider>
          )
        })}
      </Styles.SectionContent>
    </Styles.SectionContainer>
  )
}
